import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

import { ShowMoreTextWrapperTestIds } from './ShowMoreTextWrapper.testIds';

const ShowMoreTextWrapper = ({
  text,
  linesToTruncate = 2,
  showMoreText = 'Expand',
  showLessText = 'Collapse',
  wrapperClassName = 'flex flex-col',
  buttonClassName = 'self-end mt-5',
}) => {
  const ref = useRef();

  const listItemStyles = useMemo(
    () => ({
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: linesToTruncate,
      overflowY: 'hidden',
    }),
    [linesToTruncate],
  );

  const [isTextExpanded, setIsTextExpanded] = useState(false);
  const [isTextOverflow, setIsTextOverflow] = useState(false);

  useLayoutEffect(() => {
    const { clientHeight, scrollHeight } = ref.current || {};
    const isTextOverflowY = scrollHeight > clientHeight;

    setIsTextOverflow(isTextOverflowY);
  }, []);

  const onToggleTextHeight = useCallback(() => {
    setIsTextExpanded(isTextExpanded => !isTextExpanded);
  }, []);

  return (
    <div className={wrapperClassName}>
      <Box component="span" ref={ref} sx={!isTextExpanded ? listItemStyles : undefined}>
        {text}
      </Box>
      {isTextOverflow && (
        <Button
          className={buttonClassName}
          data-testid={ShowMoreTextWrapperTestIds.TOGGLE_BUTTON}
          size="small"
          type="text"
          onClick={onToggleTextHeight}
        >
          {isTextExpanded ? showLessText : showMoreText}
        </Button>
      )}
    </div>
  );
};

ShowMoreTextWrapper.propTypes = {
  text: PropTypes.string.isRequired,
  linesToTruncate: PropTypes.number,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  wrapperClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
};

export default ShowMoreTextWrapper;
